import { ActionType, createAsyncAction } from 'typesafe-actions'
import { Failure, Request, Success } from './types'
import { ChatState } from '../../types'
import { addChatInChatsState } from '../helpers'

export const updateChatAction = createAsyncAction(
  '@chat/UPDATE_CHAT_REQUEST',
  '@chat/UPDATE_CHAT_SUCCESS',
  '@chat/UPDATE_CHAT_FAILURE'
)<Request, Success, Failure>()

const success = (state: ChatState, action: ActionType<typeof updateChatAction.success>): ChatState => {
  let openChatsUpdated = []
  let inProgressChatsUpdated = []
  let finishedChatsUpdated = []
  let fixdedChatsUpdated = []

  const isActiveChat = state.activeChat?.id === action.payload.chat.id
  const activeChatUpdated = isActiveChat
    ? {
        ...state.activeChat,
        requesterPhoto: action.payload.chat.requesterPhoto,
        chatName: action.payload.chat.chatName,
        lastTickets: action.payload.chat.lastTickets,
        requesterNumber: action.payload.chat.requesterNumber,
        callPermission: action.payload.chat.callPermission
      }
    : state.activeChat

  switch (action.payload.chat.status) {
    case 'open':
      inProgressChatsUpdated = state.inProgressChats.filter(chat => chat.id !== action.payload.chat.id)
      finishedChatsUpdated = state.finishedChats.filter(chat => chat.id !== action.payload.chat.id)
      openChatsUpdated = addChatInChatsState(state.openChats, action.payload.chat)
      fixdedChatsUpdated = state.fixedChats.filter(chat => chat.id !== action.payload.chat.id)

      return {
        ...state,
        activeChat: activeChatUpdated,
        openChats: openChatsUpdated,
        inProgressChats: inProgressChatsUpdated,
        finishedChats: finishedChatsUpdated,
        fixedChats: fixdedChatsUpdated
      }
    case 'in_progress':
      openChatsUpdated = state.openChats.filter(chat => chat.id !== action.payload.chat.id)
      finishedChatsUpdated = state.finishedChats.filter(chat => chat.id !== action.payload.chat.id)

      if (action?.payload?.chat?.fixedBy) {
        fixdedChatsUpdated = addChatInChatsState(state.fixedChats, action.payload.chat)
        inProgressChatsUpdated = state.inProgressChats.filter(chat => chat.id !== action.payload.chat.id)
      } else {
        inProgressChatsUpdated = addChatInChatsState(state.inProgressChats, action.payload.chat)
        fixdedChatsUpdated = state.fixedChats.filter(chat => chat.id !== action.payload.chat.id)
      }

      return {
        ...state,
        activeChat: activeChatUpdated,
        openChats: openChatsUpdated,
        inProgressChats: inProgressChatsUpdated,
        finishedChats: finishedChatsUpdated,
        fixedChats: fixdedChatsUpdated
      }
    default:
      openChatsUpdated = state.openChats.filter(chat => chat.id !== action.payload.chat.id)
      inProgressChatsUpdated = state.inProgressChats.filter(chat => chat.id !== action.payload.chat.id)
      finishedChatsUpdated = addChatInChatsState(state.finishedChats, action.payload.chat)
      fixdedChatsUpdated = state.fixedChats.filter(chat => chat.id !== action.payload.chat.id)

      return {
        ...state,
        activeChat: activeChatUpdated,
        openChats: openChatsUpdated,
        inProgressChats: inProgressChatsUpdated,
        finishedChats: finishedChatsUpdated,
        fixedChats: fixdedChatsUpdated
      }
  }
}

export const updateChatHandle = { asyncAction: updateChatAction, success }
